import * as i0 from "@angular/core";
export class InfoCardStore {
}
InfoCardStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InfoCardStore_Factory() { return new InfoCardStore(); }, token: InfoCardStore, providedIn: "root" });
export var InfoCardStoreKeys;
(function (InfoCardStoreKeys) {
})(InfoCardStoreKeys || (InfoCardStoreKeys = {}));
